import { useContext } from 'react';
import DefaultContext from './ServiceContext';

const useService = Context => {
  const serviceContext = useContext(Context || DefaultContext);
  return serviceContext.current;
}

export default useService;
